<button type="button" (click)="save.emit(textValue)" class="btn button m-1" [ngClass]="variable.isSelected ? 'buttonSelected' : 'button'" placement="top" ngbTooltip={{description}}>
	{{label}}
</button>
